module.exports = __webpack_public_path__ + "fe3a97536b4cf891f51774d8717d890a.png";